import { useToasts } from '../lib/toast';
import { cn } from '../lib/cn';

export function Toasts() {
  const toasts = useToasts();
  return (
    <div className="pointer-events-none fixed inset-x-0 top-2 z-50 flex flex-col items-center gap-1 px-2 pt-safe sm:top-4">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cn(
            'pointer-events-auto rounded-full px-4 py-1.5 text-sm shadow-lg shadow-black/30 animate-pop',
            t.kind === 'error' && 'bg-red-600 text-white',
            t.kind === 'success' && 'bg-amber-500 text-black',
            (!t.kind || t.kind === 'info') && 'bg-zinc-800 text-zinc-100 border border-zinc-700',
          )}
        >
          {t.text}
        </div>
      ))}
    </div>
  );
}
